import request from "@/utils/request";

// 获取我的收款列表
export function getMyPayments(param) {
    return request({
        url: '/seller/getsellerpaymentlist',
        method: 'get',
        params: param
      })
}
// 获取我的退款列表
export function getMyRefunds(param) {
    return request({
        url: '/seller/getsellerrefundlist',
        method: 'get',
        params: param
    })
}

export function newSellerDailyReport(data) {
    return request({
        url: '/myaccount/newsellerdailyreport',
        method: 'post',
        data:data
    })
}


export function getMySellerDailyReport(params) {
    return request({
        url: '/myaccount/getmysellerdailyreport',
        method: 'get',
        params:params

    })
}
